import React, { Component } from 'react';

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic = "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var social = this.props.data.social;
      var resumeDownload = this.props.data.resumedownload;
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Matteo Zancanella Profile Pic" />
         </div>
         <div className="nine columns main-col">
            <h2>About Me</h2>

            <p>{bio}</p>
            <div className="row">
               <div className="columns contact-details">
                  <h2>Find Me Online</h2>
                  <p className="address">
						   <span>{name}</span><br />
						   <span>{city} {state}</span><br />
                     {social && social.map(s => (
                       <span key={s.name}><a href={s.url} target="_blank" rel="noopener noreferrer"><i className={s.className}></i> {s.name.charAt(0).toUpperCase() + s.name.slice(1)}</a><br /></span>
                     ))}
					   </p>
               </div>
               <div className="columns download">
                  <p>
                     <a href={resumeDownload} className="button" download><i className="fa fa-download"></i>Download Resume</a>
                  </p>
               </div>
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;
